'use client'

import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import { Accordion } from '@/ui/accordion/Accordion'
import { AccordionItem } from '@/ui/accordion/AccordionItem'
import { CATEGORY_IMAGE_SIZE_ICON } from '@/ui/media/cloudflare-picture-category/CloudflarePictureCategory'
import { CloudflarePicture } from '@/ui/media/cloudflare-picture/CloudflarePicture.client'
import type {
  ProductListFilterFragment,
  ProductListFilterValueFilterFragment,
} from '@gql-generated/graphql'
import { ProductListFilter } from '../product-list-filter/ProductListFilter.client'

export type ProductListFiltersCategoryAccordionProps = {
  categoryFilters: ProductListFilterFragment
  isOpened?: boolean
  isMobile?: boolean
}

export function ProductListFiltersCategoryAccordion({
  categoryFilters,
  isOpened = false,
  isMobile = false,
}: ProductListFiltersCategoryAccordionProps) {
  const filterValues = categoryFilters.values

  if (!filterValues || filterValues.length === 0) return null

  return (
    <Accordion
      opensFirst={isOpened}
      className="w-full"
      onExpandedChange={(value) =>
        pushToGtmDataLayer({
          event: 'gaEvent',
          eventCategory: 'filtres',
          eventAction: 'ouverture bloc',
          eventLabel: Array.from(value)[0]?.toString() ?? '',
        })
      }
    >
      {filterValues.map((category) => {
        const numberOfActiveFilters =
          category.__typename === 'ValueLink' && category.values
            ? category.values.filter((filter) => 'isActive' in filter && filter.isActive).length
            : 0

        const categoryImage =
          !isMobile &&
          category.__typename === 'ValueLink' &&
          category.image &&
          category.image.set?.some((item) => item.media === 'MOBILE') ? (
            <CloudflarePicture
              src={category.image.set?.[0]?.url}
              alt=""
              width={CATEGORY_IMAGE_SIZE_ICON}
              isInternalPicture
            />
          ) : undefined

        return (
          <AccordionItem
            key={`${category.title}-${category.link.value}`}
            id={`${category.title}-${category.link.value}`}
          >
            <AccordionItem.Header
              title={category.title}
              className="gap-1 px-0"
              picture={categoryImage}
              notificationCount={
                isMobile && numberOfActiveFilters > 0 ? numberOfActiveFilters : undefined
              }
            />
            <AccordionItem.Panel className="px-0">
              {category.__typename === 'ValueLink' && (
                <ProductListFilter
                  title={category.title}
                  filters={category.values as ProductListFilterValueFilterFragment[]}
                  collapsedViewItemCount={5}
                  isMobile={isMobile}
                />
              )}
            </AccordionItem.Panel>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}
